<template>
  <b-form>
    <div id="fulfillment-address">
      <div class="modal-wrp mx-1rem">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-sm-12 col-xs-12">
                <div class="information-header text-bold mb-2">
                  {{ "Address" }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'First Name'"
                  label-for="firstName"
                  label-class="font-medium-5 required"
                >
                  <b-form-input
                    id="firstName"
                    v-model="formData.firstName"
                    required
                    :disabled="disabled"
                  />
                </b-form-group>
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'Last Name'"
                  label-for="lastName"
                  label-class="font-medium-5 required"
                >
                  <b-form-input
                    id="lastName"
                    v-model="formData.lastName"
                    required
                    :disabled="disabled"
                  />
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'Contact No.'"
                  label-for="contactNo"
                  label-class="font-medium-5 required"
                >
                  <b-form-input
                    id="contactNo"
                    v-model="formData.contactNo"
                    required
                    :formatter="onInputNumber"
                    :disabled="disabled"
                  />
                </b-form-group>
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'Address'"
                  label-for="address"
                  label-class="font-medium-5"
                >
                  <b-form-input id="address" v-model="formData.address" :disabled="disabled"/>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'House No.'"
                  label-for="houseNo"
                  label-class="font-medium-5"
                >
                  <b-form-input id="houseNo" v-model="formData.houseNo" :disabled="disabled"/>
                </b-form-group>
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'Village No.'"
                  label-for="villageNo"
                  label-class="font-medium-5"
                >
                  <b-form-input id="villageNo" v-model="formData.villageNo" :disabled="disabled"/>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'Building No.'"
                  label-for="buildingNo"
                  label-class="font-medium-5"
                >
                  <b-form-input id="buildingNo" v-model="formData.buildingNo" :disabled="disabled"/>
                </b-form-group>
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'Street'"
                  label-for="street"
                  label-class="font-medium-5"
                >
                  <b-form-input id="street" v-model="formData.street" :disabled="disabled"/>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'Lane'"
                  label-for="lane"
                  label-class="font-medium-5"
                >
                  <b-form-input id="lane" v-model="formData.lane" :disabled="disabled"/>
                </b-form-group>
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'District'"
                  label-for="district"
                  label-class="font-medium-5"
                >
                  <b-form-input id="district" v-model="formData.district" :disabled="disabled"/>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'Sub-District'"
                  label-for="subDisrtrict"
                  label-class="font-medium-5"
                >
                  <b-form-input
                    id="subDisrtrict"
                    v-model="formData.subDisrtrict"
                    :disabled="disabled"
                  />
                </b-form-group>
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'Postal Code'"
                  label-for="postalCode"
                  label-class="font-medium-5"
                >
                  <b-form-input id="postalCode" v-model="formData.postalCode" :disabled="disabled"/>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'Province'"
                  label-for="province"
                  label-class="font-medium-5"
                >
                  <b-form-input id="province" v-model="formData.province" :disabled="disabled"/>
                </b-form-group>
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-form-group
                  :label="'Remark'"
                  label-for="remark"
                  label-class="font-medium-5"
                >
                  <b-form-input id="remark" v-model="formData.remarkAddress" :disabled="disabled"/>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
import useShippingDetailModal from "../../hook/useShippingDetailModal";
export default {
   props: {
    formData : {
      type: Object , 
      default: {}
    },
    disabled: {
      type: Boolean,
    }
  },
  setup() {
    const { onInputNumber } = useShippingDetailModal();

    return {
      onInputNumber,
    };
  },
};
</script>

<style>
</style>